import { v4 as uuidv4 } from 'uuid';
import {WATERFALL_SHAPES_KEY} from "../../../../../../constants";

export default class WaterfallSegment {
  id;
  key;  /* string */
  name; /* string */
  length;  /* int */
  height;  /* int */
  thickness; /* int */
  parentSection; /* object */
  isDisabled; /* bool */
  COMMON_HEIGHT = [
    // WATERFALL_SHAPES_KEY.waterfall,
    // WATERFALL_SHAPES_KEY.cabinetReturn,
    // WATERFALL_SHAPES_KEY.overhangReturn,
  ];
  USE_DEPTH_INSTEAD_OF_HEIGHT = [
    WATERFALL_SHAPES_KEY.underlayment,
    WATERFALL_SHAPES_KEY.peninsulaUnderwrap
  ];
  USE_LINE_LENGTH = [
    WATERFALL_SHAPES_KEY.underlayment,
    WATERFALL_SHAPES_KEY.waterfall
  ];

  constructor(key, name, length, height, thickness, parentSection, isDisabled = false) {
    this.id = uuidv4();
    this.key = key;
    this.name = name;
    this.length = length;
    this.height = height;
    this.thickness = thickness;
    this.parentSection = parentSection;
    this.isDisabled = isDisabled;
  }

  exportData = () => ({
    id: this.id,
    overlayId: this.getParent().id,
    key: this.key,
    name: this.name,
    height: this.height,
    thickness: this.thickness,
    length: this.length,
    isDisabled: this.isDisabled,
  })

  setIsDisabled = (value) => {
    this.isDisabled = value
  }

  getParent = () => {
    return this.parentSection
  }

  getArea = () => {
    if (this.isDisabled) {
      return 0
    }

    let area = 0;

    // this will add mitered edge area
    if (this.key === WATERFALL_SHAPES_KEY.overhangReturn) {
      area += this.height * this.thickness
    } else if (this.key === WATERFALL_SHAPES_KEY.waterfall) {
      area += (this.height * this.thickness) * 2 //we have two mitered edges from sides
    } else if (this.key === WATERFALL_SHAPES_KEY.cabinetReturn) {
      area += this.height * this.thickness
    }

    // shape area
    area += this.height * this.length

    return area
  }

  destroy = () => {

  }
}
